export const REDIRECT_POPUP_TIMESTAMP_KEY = "redirect-popup-timestamp";

export const IS_TOUCH = "ontouchstart" in window;
